import { generateId } from '@studio/models';
import { DeviceRegistryCommandKey } from '@tryiris-ai/common.protojs/api/v1/device_settings';
import type { Reboot } from './types.js';
import { locateProxy } from '#~/agent/index.js';
import { StudioError } from '#~/error/index.js';

/**
 * Reboot the specified device.
 *
 * @param deviceId - ID of the device to be rebooted.
 */
export const reboot: Reboot = async (deviceId) => {
  try {
    const proxy = locateProxy(deviceId);

    if (!proxy) {
      throw new Error('PW-79B');
    }

    await proxy.mutate(
      {
        control: {
          device: {
            [deviceId]: {
              deviceSettings: {
                [DeviceRegistryCommandKey.POWER]: {
                  action: {
                    action: 11, // @todo v2 - DeviceRegistryCommandActionKey
                    uuid: generateId()
                  }
                }
              }
            }
          }
        }
      },
      {}
    );
  } catch (cause) {
    throw new StudioError('Unable to reboot the device.', { cause });
  }
};
